import { ThemeContext } from '@/theme/ThemeProvider';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

interface LoadingMessageProps {
  height?: number;
}

const LoadingMessageContainer = styled.div<{ height: number; theme: any }>`
  height: ${({ height }) => height}px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 32;
  padding: 60px 20px;
  background: transparent;
  animation: fadeInUp 0.6s ease-out;

  @keyframes pulse {
    0% {
      opacity: 0.3;
      transform: scale(1);
    }
    100% {
      opacity: 0.8;
      transform: scale(1.1);
    }
  }

  @keyframes fadeInUp {
    0% {
      opacity: 0;
      transform: translateY(30px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const LoadingMessage = ({ height = 300 }: LoadingMessageProps) => {
  const { theme } = useContext(ThemeContext);
  const { t } = useTranslation();

  return (
    <LoadingMessageContainer height={height} theme={theme}>
      <span
        style={{
          color: theme.COLORS.textw,
          fontFamily: 'pretendard !important',
        }}
      >
        {t('Loading Data')}
      </span>

      <div
        style={{
          display: 'flex',
          gap: 8,
          marginTop: 16,
        }}
      >
        {[...Array(3)].map((_, i) => (
          <div
            key={i}
            style={{
              width: 8,
              height: 8,
              borderRadius: '50%',
              background: theme.COLORS.Prinary,
              opacity: 0.3 + i * 0.2,
              animation: `pulse 1.5s ease-in-out ${i * 0.2}s infinite alternate`,
            }}
          />
        ))}
      </div>
    </LoadingMessageContainer>
  );
};

export default LoadingMessage;
